export default "__VITE_ASSET__C0bg$z0E__"